import { jsx as _jsx } from "react/jsx-runtime";
const MetricsSeries = ({ data, line, color, strokeWidth }) => (_jsx("g", { className: "line-group", children: _jsx("path", { className: "line", d: line(data.values) ?? undefined, style: {
            stroke: color,
            strokeWidth,
        } }) }));
export default MetricsSeries;
